class CardEbookFeatured {
  constructor() {
    this.initSlick();
  }

  initSlick() {
    $('.card__carousel').slick({
      centerMode: true,
      centerPadding: '10px',
      slidesToShow: 1,
      dots: true,
      arrows: false,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: true
          }
        }
      ]
    });
  }
}

$(document).ready(function() {
  const cardEbookFeatured = new CardEbookFeatured();
});